import { reactive } from 'vue';

const listsTable = ['Account Number', 'Coupon Number', 'Source', 'State', 'Type', 'Status', 'Import'];
const accountListTable = ['Name', 'Account Number'];

export const table = reactive({
  couponLists: listsTable,
  accountLists: accountListTable,
});
